import React from 'react';
import styled from 'react-emotion';

const Wrapper = styled('div')`
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.75rem;
  width: 1.75rem;
  font-size: 14px;
  color: black;
  margin: 0 0.5rem;
  pointer-events: none;
`;

const Ellipsis = () => <Wrapper>…</Wrapper>;

export default Ellipsis;
